<script setup lang="ts">
import { repository } from "~/repository";
import NotEntitledVideo from "~/components/Video/NotEntitledVideo.vue";
import { useAuthStore } from "~/stores/auth/store";
import { ProductTypes } from "~/types";
import { getThumbnailImage } from "~/utils/common";

const route = useRoute();
const authStore = useAuthStore();
const { authenticated, user, subscription } = storeToRefs(authStore);

const { data, pending } = await useAsyncData(
  () =>
    repository.videos.getVideoById({
      videoId: Array.isArray(route.params.slug)
        ? route.params.slug.join("")
        : route.params.slug || "",
    }),
  {
    lazy: true,
    transform: (el) => {
      const now = new Date();
      const onAir = new Date(el.data.aired_at) <= now;
      return { ...el.data, onAir };
    },
  },
);

useSeoMeta({
  title: () => data.value?.title || "",
  description: () => data.value?.description || "",

  ogTitle: () => data.value?.title || "",
  ogDescription: () => data.value?.description || "",
  ogImage: () => getThumbnailImage([data.value?.images || []]) || "",

  twitterTitle: () => data.value?.title || "",
  twitterDescription: () => data.value?.description || "",
  twitterImage: () => getThumbnailImage([data.value?.images || []]) || "",
});

const isEntitledVideo = computed(() => {
  return (
    data.value?.entitled &&
    authenticated.value &&
    (subscription.value.interval !== ProductTypes.NONE ||
      user.value.emailVerified)
  );
});
</script>

<template>
  <div>
    <div class="h-20"></div>
    <div class="m-auto max-w-screen-xl px-5 py-10">
      <div v-if="pending" class="mt-20 text-center">
        <ProgressSpinner class="!h-20 !w-20" />
      </div>
      <div v-else-if="data">
        <EntitledVideo v-if="isEntitledVideo" :video="data" />
        <NotEntitledVideo v-else :video="data" />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
